import './style.scss'
import UserIndicator from '../../components/userIndicator/UserIndicator';
import HomePageSwitch from '../../components/homePageSwitch/HomePageSwitch';
import HeaderLogoLanding from './logo/HeaderLogoLanding';

function HeaderLandingPage() {

	return (
		<div className="header-wrap">
			<div className='header-top-wrap'>
				<HeaderLogoLanding />
				<HomePageSwitch isLandingPage={true} />
				<UserIndicator />
			</div>
		</div>
	)
}

export default HeaderLandingPage